import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { State } from '../models';

@Injectable({
  providedIn: 'root'
})
export class StateService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

    public getAllStates(stateSearchParam:IGlobalSearchParam):Observable<any> {
      console.log(stateSearchParam);
      return this.apiService.post(`States/SearchState`,stateSearchParam)
    }

    public getStateDetail(stateId:number):Observable<any> {
      return this.apiService.getInd(`States/${stateId}`)
    }
    
    public deleteStateDetail(stateId:number):Observable<any> {
      return this.apiService.delete(`States/${stateId}`)
    }

    public updateStateDetail(stateId:number, state:State):Observable<any> {
      return this.apiService.put(`States/${stateId}`, state)
    } 
    
    public postStateDetail(state:State):Observable<any> {
      return this.apiService.post(`States`, state)
    } 

    public ExportStateResult(stateSearchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}States/ExportState`, stateSearchParam,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }
}
